import React from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdClose } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import images from '../../constants/images';
import Audio from '../Audio';
import './Navbar.css';

const Navbar = () => {
  const { t } = useTranslation();
  const [toggleMenu, setToggleMenu] = React.useState(false);
  const currentLang = i18n.language && i18n.language.startsWith('en') ? 'en' : 'it';

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <a href="#home"><img src={images.gericht} alt="Maithai logo" /></a>
      </div>
      <ul className="app__navbar-links">
        <li className="p__cormorant"><a href="#home">Home</a></li>
        <li className="p__cormorant"><a href="#about">{t('greeting')}</a></li>
        <li className="p__cormorant"><a href="#menu">{t('prices')}</a></li>
        <li className="p__cormorant"><a href="#awards">{t('reviews')}</a></li>
        <li className="p__cormorant"><a href="#contact">{t('contacts')}</a></li>
      </ul>
      <div className="app__navbar-right">
        <div className="app__navbar-lang">
          <button
            type="button"
            className={`app__navbar-lang_btn ${currentLang === 'it' ? 'app__navbar-lang_btn--active' : ''}`}
            onClick={() => i18n.changeLanguage('it')}
          >
            Ita
          </button>
          <button
            type="button"
            className={`app__navbar-lang_btn ${currentLang === 'en' ? 'app__navbar-lang_btn--active' : ''}`}
            onClick={() => i18n.changeLanguage('en')}
          >
            Eng
          </button>
        </div>
        <Audio />
      </div>
      <div className="app__navbar-smallscreen">
        <Audio />
        <GiHamburgerMenu color="#DCCA87" fontSize={27} onClick={() => setToggleMenu(true)} />
        {toggleMenu && (
          <div className="app__navbar-smallscreen_overlay app__Sfondo flex__center slide-bottom">
            <MdClose fontSize={30} className="overlay__close" onClick={() => setToggleMenu(false)} />
            <ul className="app__navbar-smallscreen_links">
              <li><a href="#home" onClick={() => setToggleMenu(false)}>Home</a></li>
              <li><a href="#about" onClick={() => setToggleMenu(false)}>{t('greeting')}</a></li>
              <li><a href="#menu" onClick={() => setToggleMenu(false)}>{t('prices')}</a></li>
              <li><a href="#awards" onClick={() => setToggleMenu(false)}>{t('reviews')}</a></li>
              <li><a href="#contact" onClick={() => setToggleMenu(false)}>{t('contacts')}</a></li>
            </ul>
            <div className="app__navbar-smallscreen_lang">
              <button
                type="button"
                className={`app__navbar-lang_btn ${currentLang === 'it' ? 'app__navbar-lang_btn--active' : ''}`}
                onClick={() => i18n.changeLanguage('it')}
              >
                Ita
              </button>
              <button
                type="button"
                className={`app__navbar-lang_btn ${currentLang === 'en' ? 'app__navbar-lang_btn--active' : ''}`}
                onClick={() => i18n.changeLanguage('en')}
              >
                Eng
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
